import { render, staticRenderFns } from "./newHeaderFooter.vue?vue&type=template&id=7b252ea5&scoped=true"
import script from "./newHeaderFooter.vue?vue&type=script&lang=js"
export * from "./newHeaderFooter.vue?vue&type=script&lang=js"
import style0 from "./newHeaderFooter.vue?vue&type=style&index=0&id=7b252ea5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b252ea5",
  null
  
)

export default component.exports